import React from 'react';
import { Link } from 'react-router-dom';
import { Reveal } from '../components/Reveal';
import { EndNote } from '../components/EndNote';
import { SeoHead } from '../components/SeoHead';
import { fleet } from '../data/fleet';
export function Fleet() {
  return <div data-id="element-192" data-mp="qtkwc25as23x">
      <SeoHead title="Our Fleet — Mobile Pop-Up Trucks & Sampling Vehicles | Breezy Experiential" description="Breezy Experiential owns a fleet of mobile retail and culinary vehicles — a 12′ merch and sampling truck, a 22′ full-service kitchen, an 18′ food truck and a 15′ vintage retail van — operating in Los Angeles, New York, Texas and Florida." data-id="element-193" data-mp="lseyxr0ozqo2" />

      <header className="mx-auto max-w-page px-6 pb-10 pt-14 md:px-10 md:pb-16 md:pt-24" data-id="element-194" data-mp="74txs2ndo1is">
        <h1 className="font-display text-4xl font-bold uppercase leading-[0.9] md:text-7xl" data-id="element-195" data-mp="30ch4ccbe4c8">
          Our experiential <span className="text-lilac" data-id="element-196" data-mp="1ikqy0n0o27vb">fleet</span>
        </h1>
        <p className="mt-6 max-w-xl text-sm leading-relaxed text-muted" data-id="element-197" data-mp="1eg12x0du0xbg">
          Four vehicles we own outright — designed, built and maintained in
          house, wrapped for each brand and routed anywhere in the country. We
          have access to a wider network of trucks, trailers and carts when a
          program calls for it.
        </p>
      </header>

      <div className="mx-auto grid max-w-page gap-x-8 gap-y-14 px-6 pb-8 md:grid-cols-2 md:px-10" data-id="element-198" data-mp="161jcq6fyzawc">
        {fleet.map((vehicle, index) => <Reveal key={vehicle.slug} delay={index % 2 * 0.05} data-id="element-199" data-mp="9cttabop2a89" data-mpi={index}>
            <Link to={`/fleet/${vehicle.slug}`} className="group block" data-id="element-200" data-mp="dcm6j1p194jy">
              <div className={`overflow-hidden ${vehicle.fit === 'cover' ? 'bg-cream/5' : 'bg-cream'}`} data-id="element-201" data-mp="dari3dejyub4">
                <img src={vehicle.render} alt={`${vehicle.name}, a ${vehicle.length} ${vehicle.use.toLowerCase()} vehicle`} style={vehicle.focus ? {
              objectPosition: vehicle.focus
            } : undefined} className={`h-64 w-full transition-transform duration-[900ms] ease-out group-hover:scale-[1.04] md:h-80 ${vehicle.fit === 'cover' ? 'object-cover' : 'object-contain'}`} data-id="element-202" data-mp="n48e8o25wlhy" />
              </div>

              <div className="mt-4 flex items-baseline justify-between gap-4 border-t border-line pt-4" data-id="element-203" data-mp="12nqlmq0jvy0c">
                <h2 className="font-display text-lg uppercase leading-none transition-colors group-hover:text-lilac md:text-xl" data-id="element-204" data-mp="exw8s8g8e9g3">
                  {vehicle.name}{' '}
                  <span className="text-muted" data-id="element-205" data-mp="nzcjyievefld">({vehicle.length})</span>
                </h2>
                <span className="shrink-0 text-[0.6rem] uppercase tracking-micro text-muted" data-id="element-206" data-mp="nwztfgv1qwwp">
                  {vehicle.markets.join(' / ')}
                </span>
              </div>
              <p className="mt-1.5 text-[0.65rem] uppercase tracking-micro text-lilac" data-id="element-207" data-mp="1zcoiqevrw80o">
                {vehicle.use}
              </p>
            </Link>
          </Reveal>)}
      </div>

      <div className="mx-auto max-w-page px-6 pb-16 pt-10 md:px-10 md:pb-24" data-id="element-208" data-mp="22v5e71kgpdn4">
        <p className="max-w-xl text-sm leading-relaxed text-muted" data-id="element-209" data-mp="26ytovt4e4pcl">
          Need something we don’t own? We source, fabricate and permit custom
          builds — carts, trailers, shipping containers and scenic structures —
          for single activations or national tours.
        </p>
      </div>

      <EndNote data-id="element-210" data-mp="2lo9bcwww28mh" />
    </div>;
}